export default "__VITE_ASSET__txQZs6ja__"